module.exports = __webpack_public_path__ + "static/img/role.53af948.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role.png
// module id = aymu
// module chunks = 1